import mixx from '../../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'facturas',


  data() {
    return {
      loading: false,

      archivos: [],



      f_c: {
        desde: this.date_rest(this.currentdate(), -15),
        hasta: this.currentdate(),
      },

      tbv: null
    }
  },

  computed: {

  },
  mounted: function () {
    window.comp1 = this
    $('.box').boxWidget()
    this.files()
  },

  methods: {


    bajar(e) {
      return '/SERVER/scd/downloadfs/?dsis=' + this.dvids + '&a=fileC&f=' + e
    },

    descargar() {
      this.loading = true;

      let arc = this.archivos.filter((a) => { return a[1] == true });
      this.$http
        .post(
          '/SERVER/scd/fs/',
          {
            a: 'txtLotipGenerate',
            fechas: arc
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {

            let link = document.createElement('a');
            link.download = 'Txt_loteip_' + arc[0][0] + '.txt';
            let blob = new Blob([response.data.data], { type: 'text/plain' });
            link.href = window.URL.createObjectURL(blob);
            link.click();

          }
          this.loading = false
        })
    },

    files() {
      this.loading = true
      this.archivos = [];
      this.$http
        .post(
          '/SERVER/scd/fs/',
          {
            a: 'txtLotes',
            filtros: this.f_c
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status === 1) {

            this.archivos = response.data.data

            this.archivos.forEach(e => {
              e[1] = false;
            });



          } else if (response.data.status === 413) {
            alert("El intervalo de fechas supera los 31 días");
          }
          this.loading = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/fs/loteipTr/main/index.js